export default "__VITE_ASSET__DDT0fWJL__"